<!-- Modals -->
<ui-dialog
    [form]="createTenantForm.form"
    (primaryButtonPressed)="createTenant(createTenantForm.form, createTenantForm.getSchedule())"
    primaryButtonLabel="save"
    [open]="openTenantDialog"
    size="small"
    [isCloseable]="true"
    [secondaryButtonLabel]="'cancel' | translate"
    [secondaryButtonType]="'ghost'"
    (secondaryButtonPressed)="openTenantDialog = false"
    (closing)="openTenantDialog = false"
    header="{{ 'Edit' | translate }}"
>
    <app-form-create-tenant #createTenantForm></app-form-create-tenant>
</ui-dialog>

<!-- Body -->
<div class="ui basic segment" [class.loading]="isLoading">
    <app-header title="Debug"></app-header>

    <ui-banner variant="info" class="margin-bottom-4"
        >When creating a tenant in Payroll, there may be cases where data that is "valid" in HR is not valid in Payroll.
        Payroll has stricter validation for certain account numbers, sin numbers, etc. If you see a validation error, it
        means that some data is incorrect and must be corrected before proceeding.</ui-banner
    >

    <div class="ui segment">
        <!-- Tenant Buttons -->
        <app-segment-header
            *ngIf="!tenantCreationStatus"
            title="Company"
            (edit)="openTenantDialog = true"
            editLabel="Create Tenant"
        ></app-segment-header>
        <app-segment-header
            *ngIf="tenantCreationStatus === 'in_progress'"
            title="Company"
            [badgeOptions]="{ type: 'warning', label: 'IN PROGRESS' }"
        >
            <div class="buttons"><ui-button disabled type="link" class="edit">Create Tenant</ui-button></div>
        </app-segment-header>
        <app-segment-header
            *ngIf="tenantCreationStatus === 'error'"
            title="Company"
            [badgeOptions]="{ type: 'danger', label: 'ERROR' }"
        >
            <div class="buttons"><ui-button disabled type="link" class="edit">Create Tenant</ui-button></div>
        </app-segment-header>
        <app-segment-header
            *ngIf="tenantCreationStatus === 'success'"
            title="Company"
            (edit)="syncAll()"
            editLabel="Sync All (1 Time Migration)"
        ></app-segment-header>

        <!-- Tenant Information -->
        <form class="ui static form">
            <div class="inline field">
                <label>Payroll Tenant ID</label>
                {{ auth.company?.prTenantId || 'Not available' }}
            </div>
            <div class="inline field">
                <label>Payroll Company ID</label>
                {{ auth.company?.prCompanyId || 'Not available' }}
            </div>
            <div class="inline field">
                <label>Payroll Tenant Creation Status</label>
                {{ (tenantCreationStatus | titlecase) || 'Not available' }}
                <span *ngIf="tenantCreationStatus === 'error'"> - Please create a ticket for the dev team.</span>
            </div>
        </form>
    </div>

    <div *ngIf="syncErrors" class="ui segment">
        <app-segment-header title="Sync Errors" (edit)="syncErrors = false" editLabel="Dismiss"></app-segment-header>
        <pre>{{ syncErrors | json }}</pre>
    </div>

    <div class="ui table segment" [class.disabled]="!auth.company?.prTenantId">
        <app-segment-header title="Employees" [contextMenu]="true">
            <app-context-item label="Find Compensations (From Payroll - Destructive)" (click)="syncAllCompensations()">
            </app-context-item>
            <app-context-item label="Find Employees (Existing In Both)" (click)="syncAllEmployees()">
            </app-context-item>
        </app-segment-header>
        <table class="ui table">
            <thead>
                <tr>
                    <th>Employee</th>
                    <th>HR ID</th>
                    <th>PR ID</th>
                    <th>PR Job ID</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let employee of employees">
                    <td>{{ employee.fullName }}</td>
                    <td>{{ employee.id }}</td>
                    <td>{{ employee.prEmployeeId || '-' }}</td>
                    <td>{{ employee.prJobId || '-' }}</td>
                    <td>
                        <a
                            *ngIf="!employee.activeOnPayroll()"
                            (click)="addEmployee(employee)"
                            class="ui collapsing primary button"
                            >Add</a
                        >
                        <a
                            *ngIf="employee.activeOnPayroll()"
                            (click)="updateEmployee(employee)"
                            class="ui collapsing primary button"
                            >Update</a
                        >
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
